'use client';

import DOMPurify from 'dompurify';
import {useEffect} from 'react';

// NOTE: Keep sorted.
const ALLOWLIST = [
  'https://accounts.google.com/gsi/client',
  'https://payments.sandbox.google.com/payments/v4/js/integrator.js',
  'https://payments.google.com/payments/v4/js/integrator.js',
  'https://www.googletagmanager.com/debug/bootstrap',
  'https://maps.googleapis.com/maps',
];

export function TrustedTypes() {
  useEffect(() => {
    if (window.trustedTypes?.defaultPolicy) return;
    if (typeof window !== 'undefined' && window.trustedTypes?.createPolicy) {
      try {
        window.trustedTypes.createPolicy('default', {
          createHTML: dirty =>
            DOMPurify.sanitize(dirty, {RETURN_TRUSTED_TYPE: false}),
          createScriptURL: dirtyUrl => {
            for (const item of ALLOWLIST) {
              if (dirtyUrl.startsWith(item)) {
                return dirtyUrl;
              }
            }
            throw new Error(`Script URL not allowed: ${dirtyUrl}`);
          },
        });
      } catch (error) {
        // Handle the error, e.g., log it or display an error message
        console.error('Error creating trusted types policy:', error);
      }
    }
  }, []);

  return null;
}
